import React, { useEffect, useState } from 'react';
import clsx from 'clsx';
import { Dialog, DialogContent } from '@mui/material';
import GradientColorHeader from '@icoach/components/dialog/GradientColorHeader';
import Tablenization from '@icoach/components/Tablenization';
import { parseDate } from '@util/moment';
import usePrivacyToggle from '@util/hook/usePrivacyToggle';
import { guestProductionTabsItemType } from '@icoach/dataAnalysis/staticData';

const ReportDetailDialog = React.forwardRef((props, ref) => {
    const { open, sourceData, onClose } = props;
    if (!open) return null;

    const { title, apiFn, dateString, dataKeyName, tableRowsLabel, category } = sourceData;
    const [rowsData, setRowsData] = useState([]);
    const { isRevealed, toggle, renderPrivacyIcon } = usePrivacyToggle();

    const getDataApi = async (_dateString, _dataKeyName) => {
        let resp = await apiFn(_dateString, _dataKeyName);
        if (resp) {
            setRowsData(resp);
        }
    };

    const handleToggleRevealed = () => {
        const apiParams = {
            filterType: sourceData?.securityMaskFilterType,
            totalCount: rowsData?.length,
        };
        toggle(apiParams);
    };

    useEffect(
        () => {
            if (dateString && dataKeyName) {
                const _dateString = parseDate(dateString, 'YYYY-MM');
                getDataApi(_dateString, dataKeyName);
            }
        },
        // eslint-disable-next-line
        [dateString, dataKeyName],
    );

    return (
        <Dialog className={clsx('simple-content', 'dialog')} PaperProps={{ className: 'wx-80rem' }} open={open} fullWidth>
            <GradientColorHeader onClose={onClose}>{title}</GradientColorHeader>
            <DialogContent className={'pt-2 px-4 pb-4'}>
                {category !== guestProductionTabsItemType.agp && renderPrivacyIcon(handleToggleRevealed)}
                <Tablenization cardProps={{ className: 'theme-gray' }}>
                    <Tablenization.TableRowHeader headerRow={tableRowsLabel} />
                    <Tablenization.TableRowBody headerRow={tableRowsLabel} rowsData={rowsData} isRevealed={isRevealed} />
                </Tablenization>
            </DialogContent>
        </Dialog>
    );
});

export default ReportDetailDialog;
